import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
  import useIcons from '@/composables/useIcons'
  import { CourseModule } from '@/store/modules/course'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import CourseDescription from '@/components/course/CourseDescription.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import CourseModuleDuration from '@/components/course/CourseModuleDuration.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import { UserModule } from '@/store/modules/user'
  import useAuthentication from '@/composables/useAuthentication'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedCourse',
  setup(__props) {

  const { smallLogo } = useIcons()
  const { isMobileDevice } = useBreakpoint()
  const { redirect } = useAuthentication()
  const { setIsLoadingComponentViewData } = useCommonMixin()
  const fetchingCourse = ref(true)

  const promotedCourseId = computed(() => {
    return UserModule.currentCompany?.promotedCourseId
  })

  const course = computed(() => CourseModule.course)

  const totalCourseGroupModules = computed(() => {
    if (!promotedCourseId.value) return
    const courseGroupsIds = course.value?.courseGroups?.map((c) => c.id) || []
    return CourseModule.totalCourseGroupModules(promotedCourseId.value, courseGroupsIds)
  })

  const toCoursePage = () => {
    window.location.href = `/courses/${course.value!.id}/info`
  }

  const toStartPage = () => {
    window.location.href = redirect.value
  }

  if (promotedCourseId.value) {
    CourseModule.getCourse({ courseId: promotedCourseId.value }).finally(() => {
      fetchingCourse.value = false
      CourseModule.getCourseModules(CourseModule.course!.id)
    })
  } else {
    toStartPage()
  }

  watch(fetchingCourse, (value) => {
    setIsLoadingComponentViewData(value)
  })

return { __sfc: true,smallLogo, isMobileDevice, redirect, setIsLoadingComponentViewData, fetchingCourse, promotedCourseId, course, totalCourseGroupModules, toCoursePage, toStartPage, computed, ref, watch, useIcons, CourseModule, LoadingSpinner, CourseDescription, KetchUpButton, CourseModuleDuration, useBreakpoint, UserModule, useAuthentication, useCommonMixin }
}

})